import React from 'react';
import classnames from 'classnames';
import * as styles from './base.scss';
import Icon from 'Shared/Icon';
export default class Item extends React.Component {
    render() {
        const isOpen = this.props.open === this;
        return (React.createElement("div", null,
            React.createElement("div", { className: classnames(styles.accordionItemHeader, { [styles.active]: isOpen }), onClick: () => this.props.toggle(this) },
                React.createElement("span", null, this.props.label),
                React.createElement(Icon, { name: isOpen ? 'minus' : 'plus' })),
            React.createElement("div", null,
                React.createElement("div", null, isOpen && this.props.children))));
    }
}
